/**
 * Synthétise une licence locale pour la démo Cloud (Pages) à partir des modules choisis.
 * Utilise le format CUSTOM: attendu par licenseFeatures / featureService.
 */
import { normalizeModuleKey } from '../core/config/licenseFeatures';
import licensingService from '../core/services/licensingService';

export function applyCloudDemoLicense(selectedModuleKeys) {
  const keys = Array.isArray(selectedModuleKeys) ? selectedModuleKeys : [];
  const normalized = [...new Set(
    keys.map((k) => normalizeModuleKey(k)).filter(Boolean)
  )];

  const customPayload = normalized.length
    ? normalized.map((m) => `${m}:ALL`).join('|')
    : 'FACTURATION:ALL';

  licensingService.saveLicense({
    key: 'Qawaem-CLOUD-DEMO',
    valid: true,
    appType: `CUSTOM:${customPayload}`,
    keyType: 'CUSTOM',
    licenseMode: 'OFFLINE',
    activatedAt: new Date().toISOString(),
    lastChecked: new Date().toISOString(),
  });

  try {
    const featureService = require('../core/services/featureService').default;
    if (featureService.clearCache) {
      featureService.clearCache();
    }
  } catch (e) {
    /* noop */
  }
}
